module.exports = __webpack_public_path__ + "static/media/34DSS8.b06e39c4.jpg";